import { widerBreakpointKeys } from '../constants/breakpoints';

const hasWiderBreakpointValue = ({ state = {}, elementId, target, breakpointKey }) =>
  (widerBreakpointKeys[breakpointKey] || []).some(
    (widerBreakpointKey) => state[elementId]?.[target]?.[widerBreakpointKey] !== undefined
  );

export default hasWiderBreakpointValue;
